import type { TPrintBook } from './print-books'
import type { TKindleBook } from './kindle-books'

export type TDraft = {
  article_title: string | null
  audio_draft_source?: string
  audio_or_video?: 'audio' | 'video' | ''
  audio_original_link?: string
  audio_url: string
  author_email?: string
  content?: string
  created_at: string
  detected_language?: string | null
  footer_url: string | null
  id: number
  import_source: string | null
  import_type: string | null
  name: string
  project_name: string | null
  rtl: number
  status: TDraftStatus
  tags?: number[]
  thumbnail?: string
  /** Ready-made, versioned URL of the thumbnail image; the backend supplies it. */
  thumbnail_src?: string | null
  transcription_job_id: string
  transcription_length_seconds: number | null
  type: TDraftType
  unique_timestamp: string | null
  updated_at: string
  user_email?: string
  user_id: number
  enhanced?: boolean
  enhanced_version?: boolean
  print_book?: TPrintBook | null
  kindle_book?: TKindleBook | null
}

export type TDraftType = 'Standard' | 'PrintBook' | 'KindleBook' | 'AudioBook' | 'TemiJob' | 'Audio'
export type TDraftStatus = 'Transcribed' | 'In progress' | 'Downloading' | 'Failed' | ''
export type TDraftLabel = { [key: string]: string }

export type TDraftsPagination = {
  total: number
  page: number
  pages: number
}

export const DRAFT_TABS = ['standard', 'transcriptions', 'audiobooks', 'printbooks', 'kindlebooks', 'all'] as const

export type TDraftTab = (typeof DRAFT_TABS)[number]

/** One cached draft listing: the rows of a single tab plus everything that makes them valid. */
export type TDraftListing = {
  type: TDraftTab
  rows: TDraft[]
  /** Unfiltered total reported by the last page-1 fetch; null until the listing has been fetched. */
  total: number | null
  page: number
  sortBy: string
  query: string
  /** True only after an unfiltered page-1 fetch, which is what makes the rows reusable. */
  loaded: boolean
  loading: boolean
}

export type TDraftImportType = {
  type: string
  subType?: string
  newDashboard?: boolean
  book_type?: string
}

export type TSortOptions = {
  drafts: string
}

export type TUserSortOptions = {
  [key: string]: TSortOptions
}

export type TDraftSaveResponse =
  | {
      status: 'success'
      id: number
    }
  | {
      status: 'error'
      message: string
    }
export type TErrorResponse = {
  status: 'error'
  message: string
}
export type TModerationErrorResponse = {
  status: 'moderation_error'
  message: string
}
export type TEnhanceSuccessResponse = {
  status: 'success'
  result: {
    content: string
  }
  creditsLeft: number
  totalTokenUsed: number
}

export type TDraftFlags = {
  [key: string]: string | boolean | number
}

/** What a thumbnail generation returns: the file name plus its versioned URL. */
export type TDraftThumbnail = {
  thumbnail: string
  thumbnail_src: string | null
}
